import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-product-category-list',
  templateUrl: './product-category-list.component.html',
  styleUrls: ['./product-category-list.component.css']
})
export class ProductCategoryListComponent implements OnInit {

  productCategoryList: any= []
  page: number = 0;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleProductCategoryData: any= []
  isView: any = false
  isAdd: any = false
  isEdit: any = false
  first: number = 0;
  isLoading: any = false



  cProductList: any= []
  name:any = ""
  description:any = ""
  cid:any;
  done:any = [];
  imageUrl:any = ""
  categoryList:any = [];
  selectedCategoryList:any = [];
  subCategoryList:any = [];
  isHomePage:boolean = false;
  dropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'productCategoryId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid');
    this.getallproduct()
    this.getAllProductCategory();
  }

  getallproduct(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response);
        for(let i=0; i<response.response.length; i++) {
          let defaultUOM:any = ""
          if(response.response[i].supportedUOM != null && response.response[i].supportedUOM != undefined && response.response[i].supportedUOM.length != 0) {
            for(let j=0; j<response.response[i].supportedUOM.length; j++){
              if(response.response[i].supportedUOM[j].isDefault === true) {
                defaultUOM = response.response[i].supportedUOM[j].uomName
              }
            }
          }
          response.response[i].defaultUOM = defaultUOM
        }
        this.cProductList = [];
        for(let i=0; i<response.response.length;i++){
          let body = {
            "productId": response.response[i].productMasterId,
            "name": response.response[i].name,
            "uom": response.response[i].defaultUOM,
            "quantity": 1,
            "price": 0,
            "productUrl": response.response[i].imageUrl,
          }
          this.cProductList.push(body)
        }
        console.log(this.cProductList)
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event.page+1;
  }

  getAllProductCategory(){
    this.isLoading = true

    this.generic_service.getAllProductCategory().subscribe(
      (response:any)=>{
        console.log(response);
        this.productCategoryList = response.response
        this.categoryList = response.response
        this.count = response.response.length
        this.isLoading = false

      }
    )
  }



  getProductCategoryById(productCategoryId:any){
    this.generic_service.getProductCategoryById(productCategoryId).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleProductCategoryData = []
        this.singleProductCategoryData.push(res.response)
      
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  getProductCategoryById1(productCategoryId:any){
    this.generic_service.getProductCategoryById(productCategoryId).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleProductCategoryData = []
        this.singleProductCategoryData.push(res.response)
        this.name = res.response.name;
        this.description = res.response.description;
        this.cid = res.response.cid;
        this.done = res.response.productObjList;
        this.imageUrl = res.response.imageUrl;
        this.isHomePage = res.response.isHomePage;
        let subCategoryList:any = []
        for(let i = 0; i < res.response.subCategoryList.length;i++) {
          subCategoryList.push(
            {
              productCategoryId: res.response.subCategoryList[i].categoryId,
              name: res.response.subCategoryList[i].categoryName
            }
          )
        }
        this.subCategoryList = subCategoryList
        this.isEdit = true;
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeDelete")?.click()

  }

  closeView(){
    this.isView = false;
  }

  closeAdd(){
    this.isAdd = false;
  }

  openAdd(){
    this.isAdd = true;
  }

  closeEdit() {
    this.isEdit = false;
  }



  imageButtonClick(){
    document.getElementById("imageInput")?.click()
  }

  imageRemove(){
    this.imageUrl = ""
  }

  onChange(event: any) {
    this.onUpload(event.target.files[0])
  }

  onUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        this.imageUrl = event.response
      }
    );
  }

  // getAllCProduct(){
  //   this.generic_service.getAllcProductMaster().subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.cProductList = [];
  //       for(let i=0; i<response.response.length;i++){
  //         let body = {
  //           "slNo": 0,
  //           "productId": response.response[i].cproductId,
  //           "code": response.response[i].code,
  //           "name": String(response.response[i].name),
  //           "group": String(response.response[i].group),
  //           "description": String(response.response[i].description),
  //         }
  //         this.cProductList.push(body)
  //       }
  //     }
  //   )
  // }

  add(){
 
    // let subCategoryList: any = []
    // for(let i = 0; i < this.subCategoryList.length;i++){
    //   subCategoryList.push(
    //     {
    //       "categoryId": this.subCategoryList[i].productCategoryId,
    //       "categoryName": this.subCategoryList[i].name,
    //       "url": ""
    //     }
    //   )
    // }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.description,
      "id": "",
      "slNo": 0,
      "productCategoryId": 0,
      "name": this.name,
      "subCategoryList": this.subCategoryList,
      "productObjList": this.done,
      "cid": Number(this.cid),
      "isHomePage": this.isHomePage,
      "imageUrl": this.imageUrl
    }
    console.log(body)
    this.generic_service.addProductCategory(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllProductCategory()
        this.getallproduct()
        this.closeAdd()
        this.name = ""
        this.description = ""
        this.done = [];
        this.subCategoryList = [];
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  } 


  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  onItemSelect(item: any) {
    console.log(item);
    // let productIndex = 0;
    // for(let i = 0; i < this.relatedProductList.length;i++) {
    //   if(this.relatedProductList[i].productMasterId == item.productMasterId) {
    //     productIndex = i;
    //   }
    // }
    // this.relatedProductList.splice(productIndex,1)
    for(let i = 0; i < this.categoryList.length;i++){
      if(this.categoryList[i].productCategoryId == item.productCategoryId){
        this.subCategoryList.push(
          {
            "categoryId": this.categoryList[i].productCategoryId,
            "categoryName": this.categoryList[i].name,
            "url": this.categoryList[i].imageUrl
          }
        )
      }

    }
  }

  onSelectAll(items: any) {
    console.log(items);

  }



  deleteProductCategoryId: any
  selectProductCategory(id:any){
    this.deleteProductCategoryId = id
  }

  deleteProductCategory(){
    this.generic_service.deleteProductCategory(this.deleteProductCategoryId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllProductCategory()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }


  editProductCategory(){
 
    let subCategoryList: any = []
    for(let i = 0; i < this.subCategoryList.length;i++){
      subCategoryList.push(
        {
          "categoryId": this.subCategoryList[i].productCategoryId,
          "categoryName": this.subCategoryList[i].name,
          "url": ""
        }
      )
    }

    for(let i = 0; i < this.categoryList.length;i++){
      for(let j = 0; j < subCategoryList.length;j++){
        if(subCategoryList[j].categoryId == this.categoryList[i].productCategoryId){
          subCategoryList[j].url = this.categoryList[i].imageUrl
        }
      }

    }

    // for(let i = 0; i < this.subCategoryList.length;i++){
    //   subCategoryList.push(
    //     {
    //       "categoryId": this.subCategoryList[i].productCategoryId,
    //       "categoryName": this.subCategoryList[i].name,
    //       "url": this.subCategoryList[i].imageUrl
    //     }
    //   )
    // }

    let body = {
      "version": 0,
      "isActive": true,
      "description": this.description,
      "id": this.singleProductCategoryData[0].id,
      "slNo": 0,
      "productCategoryId": this.singleProductCategoryData[0].productCategoryId,
      "name": this.name,
      "imageUrl": this.imageUrl,
      "subCategoryList": subCategoryList,
      "productObjList": this.done,
      "cid": Number(this.cid),
      "isHomePage": this.isHomePage
    }

    console.log(body)
    this.generic_service.editProductCategory(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllProductCategory()
        this.getallproduct()
        this.name = ""
        this.description = ""
        this.done = [];
        this.subCategoryList = [];
        this.isEdit = false;
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  } 



}